import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectAllOption: {
		id: 'project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.menu-with-footer.select-all-option',
		defaultMessage: 'Select all',
		description: 'Text for selecting all options in the entity selector',
	},
});
